// Route table for the whole site:
//   /          static "you need an invitation link" page
//   /t/:token  the one-time candidate test flow
//   /r/:token  read-only results behind an expiring share link
//   /admin     the password-protected dashboard
// Anything else falls back to the root page — this site has no other
// surface area, so a 404 page would just be the same message twice.

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HomePage } from "@/routes/Home";
import { TestPage } from "@/routes/TestPage";
import { AdminPage } from "@/routes/AdminPage";
import { SharePage } from "@/routes/SharePage";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/t/:token" element={<TestPage />} />
        <Route path="/r/:token" element={<SharePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}
